import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "content-box" }
const _hoisted_3 = {
  key: 0,
  class: "error"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Thanks for registering! You can now start looking for item boxes in The 'Shroom!", -1)
const _hoisted_6 = { class: "form-row" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["href"]
const _hoisted_10 = {
  key: 2,
  class: "form-row"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Username", -1)
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 3,
  class: "form-row"
}
const _hoisted_14 = {
  class: "g-recaptcha",
  ref: "recaptchaContainer"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "smallprint" }, [
  /*#__PURE__*/_createTextVNode(" By signing up, you agree to us collecting your name (if you provide one), your browser and your IP address, in order to announce winners, keep statistics, troubleshoot problems, and to combat potential spam. No other data will be collected."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" You also agree to a cookie being placed in your browser to identify you when you look for items. This cookie will automatically expire 30 days after you last visited this site. ")
], -1)
const _hoisted_16 = {
  key: 4,
  class: "error"
}
const _hoisted_17 = {
  key: 5,
  class: "message error"
}
const _hoisted_18 = {
  key: 6,
  class: "message error"
}
const _hoisted_19 = {
  key: 7,
  class: "form-row"
}
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  key: 8,
  class: "loading"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1),
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.error), 1))
        : (!_ctx.loaded)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Loading..."))
          : (_ctx.complete)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_router_link, {
                    to: {name: 'home'},
                    replace: true,
                    class: "sign-up button"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Overview")
                    ]),
                    _: 1
                  })
                ])
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createElementVNode("p", null, [
                  _createTextVNode("Hi there" + _toDisplayString(_ctx.activeUsername ? ' ' + _ctx.activeUsername : '') + "! Welcome to ", 1),
                  _createElementVNode("i", null, _toDisplayString(_ctx.title), 1),
                  _createTextVNode("!")
                ]),
                (_ctx.activeGameTitle)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                      _createTextVNode("You're currently playing "),
                      _createElementVNode("i", null, _toDisplayString(_ctx.activeGameTitle), 1),
                      _createTextVNode(" in this browser. It's not possible to play multiple games simultaneously, but you can switch over and resume that game later if you want.")
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.activeUsername)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, "To start the game, please enter your username in the box below if you want us to personally congratulate you on finding all items throughout The 'Shroom. If you want to play anonymously, simply leave the field empty."))
                  : _createCommentVNode("", true),
                _createElementVNode("p", null, [
                  _createTextVNode("View the special 'Shroom section "),
                  _createElementVNode("a", {
                    href: _ctx.hubUrl,
                    target: "_blank"
                  }, "here", 8, _hoisted_9),
                  _createTextVNode(" for more information.")
                ]),
                (!_ctx.activeUsername)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _hoisted_11,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "name",
                        name: "name",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
                        maxlength: "100",
                        disabled: !_ctx.formLoaded || !_ctx.thirdPartyCookies
                      }, null, 8, _hoisted_12), [
                        [_vModelText, _ctx.username]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.activeGameTitle && _ctx.thirdPartyCookies)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, null, 512)
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_15,
                (_ctx.formError)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.formError), 1))
                  : _createCommentVNode("", true),
                (_ctx.thirdPartyCookies === null)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_17, "Unable to check if third-party cookies are enabled. Ensure that third-party cookies are enabled and try again."))
                  : (_ctx.thirdPartyCookies === false)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_18, "It looks like third-party cookies are disabled, which are needed for this game to function. Ensure that third-party cookies are enabled and then reload this site."))
                    : _createCommentVNode("", true),
                (_ctx.thirdPartyCookies)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("button", {
                        class: "sign-up button",
                        type: "button",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.register && _ctx.register(...args))),
                        disabled: !_ctx.formLoaded
                      }, " Sign up! ", 8, _hoisted_20)
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.formLoaded)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_21, "Loading..."))
                  : _createCommentVNode("", true)
              ], 64))
    ])
  ]))
}